import React from 'react'
import { IoIosCloseCircleOutline } from 'react-icons/io'

import './CloseButton.css'

interface CloseButtonPropsType {
  handleClose: () => void
}

export const CloseButton = ({ handleClose }: CloseButtonPropsType) => {
  return (
    <button className="will-filter-bar-close-button" onClick={handleClose}>
      <IoIosCloseCircleOutline />
    </button>
  )
}
